<div class="app-container">
  <nz-layout>
    @if (showChrome()) {
      <nz-header class="app-header">
        <div class="app-header-inner">
          <button
            type="button"
            class="app-nav-toggle"
            (click)="toggleDrawer()"
            aria-label="Abrir menú"
          >
            <span nz-icon nzType="menu" nzTheme="outline"></span>
          </button>

          <div class="app-brand">
            <span class="app-brand-mark" aria-hidden="true">
              <span nz-icon nzType="bank" nzTheme="outline"></span>
            </span>
            <div class="app-brand-copy">
              <span class="app-brand-text">Estados de Cuenta</span>
              <span class="app-brand-sub">Tesorería</span>
            </div>
          </div>

          <ul nz-menu nzMode="horizontal" nzTheme="dark" class="app-nav">
            <li nz-menu-item>
              <a routerLink="/dashboard" routerLinkActive="active">
                <span nz-icon nzType="dashboard" nzTheme="outline"></span>
                <span>Dashboard</span>
              </a>
            </li>
            <li nz-menu-item>
              <a routerLink="/statements" routerLinkActive="active">
                <span nz-icon nzType="file-text" nzTheme="outline"></span>
                <span>Estados de Cuenta</span>
              </a>
            </li>
            <li nz-menu-item>
              <a routerLink="/editar-registros" routerLinkActive="active">
                <span nz-icon nzType="edit" nzTheme="outline"></span>
                <span>Editar registros</span>
              </a>
            </li>
            <li nz-menu-item>
              <a routerLink="/editar-empresas" routerLinkActive="active">
                <span nz-icon nzType="bank" nzTheme="outline"></span>
                <span>Empresas</span>
              </a>
            </li>
            <li nz-menu-item>
              <a routerLink="/carga-masiva" routerLinkActive="active">
                <span nz-icon nzType="folder-add" nzTheme="outline"></span>
                <span>Carga masiva</span>
              </a>
            </li>
          </ul>

          <div class="app-user">
            @if (currentUser(); as user) {
              <span class="app-user__chip" aria-hidden="true">
                <span nz-icon nzType="user" nzTheme="outline"></span>
                <span class="app-user__name">{{ user.displayName }}</span>
              </span>
            }
            <button
              type="button"
              class="app-user__logout"
              (click)="logout()"
              nz-tooltip
              nzTooltipTitle="Cerrar sesión"
              aria-label="Cerrar sesión"
            >
              <span nz-icon nzType="logout" nzTheme="outline"></span>
              <span class="app-user__logout-text">Salir</span>
            </button>
          </div>
        </div>
      </nz-header>
    }
    <nz-content class="app-content" [class.app-content--bare]="!showChrome()">
      <router-outlet />
    </nz-content>
  </nz-layout>
</div>

<nz-drawer
  [nzVisible]="drawerOpen()"
  nzPlacement="left"
  [nzWidth]="280"
  [nzClosable]="true"
  nzTitle="Navegación"
  (nzOnClose)="closeDrawer()"
  nzWrapClassName="app-drawer"
>
  <ng-container *nzDrawerContent>
    <nav class="app-drawer-nav">
      <a routerLink="/dashboard" routerLinkActive="active" (click)="closeDrawer()">
        <span nz-icon nzType="dashboard" nzTheme="outline"></span>
        <span>Dashboard</span>
      </a>
      <a routerLink="/statements" routerLinkActive="active" (click)="closeDrawer()">
        <span nz-icon nzType="file-text" nzTheme="outline"></span>
        <span>Estados de Cuenta</span>
      </a>
      <a routerLink="/editar-registros" routerLinkActive="active" (click)="closeDrawer()">
        <span nz-icon nzType="edit" nzTheme="outline"></span>
        <span>Editar registros</span>
      </a>
      <a routerLink="/editar-empresas" routerLinkActive="active" (click)="closeDrawer()">
        <span nz-icon nzType="bank" nzTheme="outline"></span>
        <span>Empresas</span>
      </a>
      <a routerLink="/carga-masiva" routerLinkActive="active" (click)="closeDrawer()">
        <span nz-icon nzType="folder-add" nzTheme="outline"></span>
        <span>Carga masiva</span>
      </a>
    </nav>
  </ng-container>
</nz-drawer>
